<template>
    <div>
      <div class="columns is-gapless is-paddingless is-mobile" style="margin: 0;" v-if="type=='chain'">
              <div class="column is-11" style="margin: 0;">
                <b-checkbox
                    :size="size" type="is-teal"
                      native-value="Preferred Vendors Only"
                      id="Preferred Vendors Only"
                    v-model="valueAmenities"
                   >
                    Preferred Vendors Only
                </b-checkbox>
              </div>
            
            </div>
          <div v-for="chain in Object.keys(fullItems)" :key="chain">
            <div class="columns is-gapless is-paddingless is-mobile" style="margin: 0;">
              <div class="column is-11" style="margin: 0;">
                <b-checkbox
                    :size="size" type="is-teal"
                    :native-value="chain"
                    :id="chain"
                    v-model="valueAmenities"
                    :disabled="!(filteredItems[chain] || value.includes(chain))">
                    {{chain}}
                </b-checkbox>
              </div>
              <div :class="['column', 'is-1', size == 'is-small' ? 'is-size-7' : 'is-size-5']" style="margin: 0; text-align: right; color: gray; text-align: right;">
                <div v-if="filteredItems[chain]">
                  {{filteredItems[chain]}}
                </div>
                <div v-else>
                  0
                </div>
              </div>
            </div>
          </div>
    </div>
</template>

<script>
    export default {
      name: 'SelectionWithQuantityDisplay',
      data() {
          return {
            valueAmenities: this.value,
          }
      },
      props: {
        fullItems: Object,
        filteredItems: Object,
        value: Array,
        size: {
          type: String,
          default: 'is-small'
        },
        type:String
      },
      methods: {
        handleInput () {
          this.$emit('input', this.selectedChains);
        }
      },
      watch:{
        valueAmenities: function(){
          this.$emit('input', this.valueAmenities);
        }
      }
    }
</script>

<style lang="scss" scoped>
</style>
